import type { Lang } from "@/i18n/languages";

export function buildLangPathname(lang: Lang, strippedPathname: string): string {
  const sub = strippedPathname === "/" ? "" : strippedPathname;
  return `/${lang}${sub}`;
}

